export const environment = {
  apiPath: 'https://api.dev.finbricks.com',
  cdnPath: 'https://cdn.dev.finbricks.com',
  locale: 'sk',
  transitionScreenWaitTime: 5000,
  sentryEnv: 'DEV',
  sentryEnabled: true
};
